<template>
<!-- Header Area wrapper Starts -->
<header id="header-wrap">
    <div id="nav-bar">
        <div class="top-info fixed-top">
            <div class="container-fluid full-height">
                <div class="row full-height">
                    <div class="col-md-6 d-none d-sm-block full-height">
                        <div class="navbar-callus text-left sm-text-center">
                            <ul class="list-inline">
                                <li><a href="tel:+17867012401"><i class="fa fa-phone"></i> {{$t('callus')}}: +1 786 701 2401</a></li>
                                <li class=""><a href="mailto:dttcoaching@gmail.com?Subject=Contacting"><i
                                        class="fa fa-envelope-o"></i> {{$t('contactus')}}: dttcoaching@gmail.com</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 text-left full-height">
                        <LanguagePickerCmp />
                    </div>
                </div>
            </div>

        </div>
        <!-- Navbar Start -->
        <nav class="navbar navbar-expand-md bg-inverse fixed-top scrolling-navbar no-lateral-padding ">


            <div class="container-fluid no-padding">
                <!-- Brand and toggle get grouped for better mobile display -->
                <a href="index.html" class="navbar-brand col-8 col-md-3"><img src="../assets/img/logo.png" alt=""></a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                    <i class="lni-menu"></i>
                </button>
                <!--                "v-b-scrollspy={element: '#app', offset: 80}"-->
                <div class="collapse navbar-collapse col-md-9" id="navbarCollapse"  >
                    <ul class="navbar-nav mr-auto w-100 justify-content-end clearfix" v-b-scrollspy:app>
                        <!--                        <li class="nav-item" v-for="(menu, index) in listMenu"-->
                        <!--                            v-bind:class="{ active: menu.active }"-->
                        <!--                            v-on:click="changeLink(menu)"-->
                        <!--                            :key="`link${index}`">-->
                        <!--                            <a class="nav-link"  :href="`#${menu.key}`" >-->
                        <!--                                {{$t(menu.title)}}-->
                        <!--                            </a>-->

                        <!--                        </li>-->
                        <li class="nav-item ">
                            <router-link to="/" exact class="nav-link internal">{{$t('menus.Home')}}</router-link>
                        </li>
                        <li class="nav-item">
                             <router-link to="/about" class="nav-link internal"> {{$t('menus.AboutUs')}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/ourstaff" class="nav-link internal">{{$t('menus.OurStaff')}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/services" class="nav-link internal">{{$t('menus.Services')}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/carf" class="nav-link internal">{{$t('menus.Carf')}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/news" class="nav-link internal">{{$t('menus.News')}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/contact" class="nav-link internal">{{$t('menus.Contact')}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/clients" class="nav-link internal">{{$t('menus.Clients')}}</router-link>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link external" target="_blank" href="https://app.dttcoaching.com">
                                {{$t('login')}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <!-- Navbar End -->
    </div>
</header>


</template>

<script>
    import LanguagePickerCmp from '../components/LanguagePickerCmp'
    export default {
        name: "Navbar",
        components: {
            LanguagePickerCmp
        },
        data() {
            const menus = [
                {
                    title: "menus.Home",
                    key: "home-area",
                    active: true
                },
                {
                    title: "menus.AboutUs",
                    key: "cta",
                    active: false
                },
                {
                    title: "menus.OurStaff",
                    key: "features",
                    active: false
                },
                {
                    title: "menus.Services",
                    key: "services",
                    active: false
                },
                {
                    title: "menus.Carf",
                    key: "team",
                    active: false
                },
                {
                    title: "menus.Contact",
                    key: "contact",
                    active: false
                },
                {
                    title: "menus.Clients",
                    key: "testimonial",
                    active: false
                }
            ];

            // langs.find( f => f.value === this.$i18n.locale).active = true;
            return {
                listMenu: menus
            };
        },
        computed:{

        },
        methods: {
            changeLink(menu) {
                this.listMenu.find( f => f.key != menu.key).active = false;
                this.listMenu.find( f => f.key === menu.key).active = true;
            }
        }
    }
</script>

<style scoped>

</style>
